/**
 * Whether the game build players are running actually reads what these screens
 * save.
 *
 * Game Set Up (remote config, including the game-open hours) and Weapon Balance
 * both store values we deliver, and both screens used to call a saved value
 * "live" or "Running now". Production build 3446 reads PreseasonGames from Unity
 * Gaming Services and applies none of the remote config keys or weapon stats, so
 * those words described a value no player receives (audit CFG-03, CFG-10,
 * CFG-26, CFG-50).
 *
 * One place to flip when a build that reads them ships, so the labels change
 * together rather than one screen at a time. Editing is unaffected either way:
 * the values are still saved and still delivered to any build that asks.
 */
export const CURRENT_GAME_BUILD = '3446'

export const BUILD_READS_REMOTE_CONFIG = false
export const BUILD_READS_WEAPON_BALANCE = false

export const NOT_READ_BY_BUILD = `Saved; not read by the current game build (${CURRENT_GAME_BUILD})`
